ear logic for these enquiries
<template>
  <v-container fluid>
    <material-card icon="mdi-clipboard-text" inline :title="title">
      <v-card-actions>
        <a @click="$router.back()">
          <v-btn
            v-if="$vuetify.breakpoint.smAndUp"
            elevation="1"
            absolute
            right
            top
          >
            <v-icon left>mdi-arrow-left</v-icon>back
          </v-btn>
          <v-btn
            v-else
            fixed
            right
            fab
            small
            color="grey lighten-2"
            elevation="1"
            class="mr-n2 mt-10"
            style="opacity: 0.6"
          >
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        </a>
      </v-card-actions>
      <v-card-component>
        <form
          autocomplete="off"
          @submit.prevent="
            save()
            uploadFile()
          "
        >
          <v-row>
            <v-col class="mt-2" cols="12" sm="3">
              <label class="font-weight-medium body-2">
                Theme Name
                <span class="requir error--text">*</span>
              </label>
              <v-autocomplete
                placeholder="Select Theme"
                class="my-0 py-1"
                v-model="themeName"
                required
                v-on:change="fetchSkills()"
                item-value="id"
                :items="themeList"
                key="id"
                item-text="name"
              >
              </v-autocomplete>
            </v-col>
            <v-col class="mt-2" cols="12" sm="3">
              <label class="font-weight-medium body-2">
                Skill
                <span class="requir error--text">*</span>
              </label>
              <v-autocomplete
                placeholder="Enter Skill Name"
                class="my-0 py-1"
                v-model="skills"
                item-value="name"
                :items="themeWiseSkills"
                key="id"
                item-text="name"
                multiple
              >
              </v-autocomplete>
            </v-col>
            <v-col class="mt-2" cols="12" sm="3">
              <label class="font-weight-medium body-2">
                Goal
                <span class="requir error--text">*</span>
              </label>
              <v-text-field
                counter="100"
                required
                v-model.trim="goal"
                placeholder="Enter Goal"
                maxlength="100"
              ></v-text-field>
            </v-col>
            <v-col class="mt-2" cols="12" sm="3">
              <label class="font-weight-medium body-2">
                Developmental Area
                <span class="requir error--text">*</span>
              </label>
              <v-text-field
                counter="100"
                required
                v-model.trim="developmentArea"
                placeholder="Enter Developmental Area"
                maxlength="100"
              ></v-text-field>
            </v-col>
            <v-col class="mt-2" cols="12" sm="3">
              <label class="font-weight-medium body-2">
                Outcome
                <span class="requir error--text">*</span>
              </label>
              <v-text-field
                counter="100"
                required
                v-model.trim="outcome"
                placeholder="Enter Outcome"
                maxlength="100"
              ></v-text-field>
            </v-col>
            <v-col class="mt-2" cols="12" sm="3">
              <label class="font-weight-medium body-2">
                Resource from WOW Kit Area
                <span class="requir error--text">*</span>
              </label>
              <v-text-field
                counter="100"
                required
                v-model.trim="resourceFromWowKit"
                placeholder="Enter Resource from WOW Kit Area"
                maxlength="100"
              ></v-text-field>
            </v-col>
            <v-col class="mt-2" cols="12" sm="3">
              <label class="font-weight-medium body-2">
                Others
                <span class="requir error--text">*</span>
              </label>
              <v-text-field
                counter="100"
                required
                v-model.trim="others"
                placeholder="Enter Others Section"
                maxlength="100"
              ></v-text-field>
            </v-col>
            <v-col class="mt-2" cols="12" sm="3">
              <label class="font-weight-medium body-2">
                Preparation
                <span class="requir error--text">*</span>
              </label>
              <v-text-field
                counter="100"
                required
                v-model.trim="preparation"
                placeholder="Enter Preparation"
                maxlength="100"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="12">
              <label class="font-weight-medium body-2"> Procedure </label>
              <div v-for="(n, i) of procedure" :key="i">
                <v-card-component>
                  <v-row>
                    <v-col cols="12" md="11" class="pt-0 pb-0">
                      <v-row>
                        <v-col cols="12" sm="3">
                          <v-text-field
                            class="my-0 py-4"
                            counter="100"
                            placeholder="Procedure Title"
                            :required="i === 0"
                            v-model.trim="procedure[i].stepTitle"
                            maxlength="100"
                          >
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="3">
                          <v-text-field
                            type="number"
                            min="1"
                            class="my-0 py-4"
                            counter="100"
                            placeholder="Procedure Time in Mins"
                            :required="i === 0"
                            v-model.trim="procedure[i].stepTime"
                            maxlength="100"
                          >
                          </v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                    <!--Sub step starts-->
                    <v-col cols="12" md="10">
                      <div v-for="(n, i) of steps" :key="i">
                        <v-card-component>
                          <v-row>
                            <v-col cols="12" md="11" class="pt-0 pb-0">
                              <v-row>
                                <v-col cols="12" md="2">
                                  <v-text-field
                                    class="my-0 py-4"
                                    type="number"
                                    min="1"
                                    placeholder="Position"
                                    v-model.trim="steps[i].position"
                                    maxlength="100"
                                  >
                                  </v-text-field>
                                </v-col>
                                <v-col cols="12" sm="5">
                                  <v-textarea
                                    label="Steps"
                                    auto-grow
                                    v-model.trim="steps[i].steps"
                                    rows="3"
                                    row-height="25"
                                    :required="i === 0"
                                    clearable
                                  ></v-textarea>
                                </v-col>
                                <v-col
                                  cols="12"
                                  sm="3"
                                  class="d-flex pt-0 pb-5 flex-column justify-center align-center"
                                >
                                  <v-file-input
                                    small-chips
                                    multiple
                                    @change="onFilechange(steps[i].file)"
                                    v-model="steps[i].file"
                                    placeholder="Click to Upload"
                                    :messages="[
                                      '(max file size allowed 100MB)'
                                    ]"
                                    accept=".pdf,.png,.jpeg,.jpg"
                                  ></v-file-input>
                                  <span class="has-text-danger"
                                    >Allowed files: '.pdf, .png, jpg,
                                    jpeg.</span
                                  >
                                  <!-- <div v-if="steps[i].file.length > 0"> -->
                                  <div>
                                    <v-chip
                                      v-for="(file, i) in steps[i].file"
                                      :key="i"
                                      color="primary"
                                      label
                                      multiple
                                      outlined
                                      class="ma-2"
                                      close
                                      @click:close="
                                        deleteDropFile(steps[i].file, i)
                                      "
                                    >
                                      {{ file.name }}
                                    </v-chip>
                                  </div>
                                </v-col>
                                <v-col cols="12" sm="2">
                                  <v-checkbox
                                    label="is file downloadable*"
                                    v-model="steps[i].isDownloadableValue"
                                  ></v-checkbox>
                                </v-col>
                              </v-row>
                            </v-col>
                            <v-col
                              cols="12"
                              md="1"
                              class="d-flex pt-0 pb-0 flex-column justify-center align-center"
                            >
                              <label class="font-weight-medium body-2"
                                >No. {{ i + 1 }}</label
                              >

                              <v-card-actions>
                                <v-btn
                                  title="Delete skill"
                                  elevation="1"
                                  color="error"
                                  @click="deleteStepsRow(i, steps[i])"
                                >
                                  <v-icon left> mdi-trash-can </v-icon>
                                </v-btn>
                              </v-card-actions>
                            </v-col>
                          </v-row>
                        </v-card-component>
                      </div>
                      <v-card-actions class="d-flex justify-end">
                        <v-btn
                          bottom
                          right
                          elevation="1"
                          color="primary"
                          @click="
                            steps.push({
                              position: '',
                              steps: ''
                            })
                          "
                        >
                          <v-icon left> mdi-plus </v-icon>
                          Add Steps
                        </v-btn>
                      </v-card-actions>
                    </v-col>
                    <!--ends-->
                    <v-col
                      cols="12"
                      md="2"
                      class="d-flex pt-0 pb-0 flex-column justify-center align-center"
                    >
                      <label class="font-weight-medium body-2"
                        >No. {{ i + 1 }}</label
                      >

                      <v-card-actions>
                        <v-btn
                          title="Delete skill"
                          elevation="1"
                          color="error"
                          @click="deleteProcedureRow(i, steps[i])"
                        >
                          <v-icon left> mdi-trash-can </v-icon>
                        </v-btn>
                      </v-card-actions>
                    </v-col>
                  </v-row>
                </v-card-component>
              </div>
              <v-card-actions class="d-flex justify-end">
                <v-btn
                  bottom
                  right
                  elevation="1"
                  color="primary"
                  @click="
                    procedure.push({
                      step: '',
                      time: ''
                    })
                  "
                >
                  <v-icon left> mdi-plus </v-icon>
                  Add Procedure
                </v-btn>
              </v-card-actions>
            </v-col>

            <v-col cols="12">
              <v-card-actions class="d-flex justify-end">
                <v-btn bottom right elevation="1" color="primary" type="submit">
                  <v-icon left> mdi-content-save </v-icon>
                  Save all
                </v-btn>
              </v-card-actions>
            </v-col>
          </v-row>
        </form>
      </v-card-component>
    </material-card>
  </v-container>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import _ from 'lodash'

import MaterialCard from '@/components/template/MaterialCard'
import VCardComponent from '@/components/template/VCardComponent'

export default {
  components: { VCardComponent, MaterialCard },
  props: ['dayId'],
  data () {
    return {
      skills: [],
      goal: '',
      developmentArea: '',
      outcome: '',
      name: '',
      resourceFromWowKit: '',
      others: '',
      preparation: '',
      procedures: [],
      themeName: '',
      selectedDay: '',
      classTime: '',
      classList: [],
      procedure: [
        {
          stepTitle: '',
          stepTime: ''
          // isDownloadableValue: false
        }
      ],
      isDownloadableValue: false,
      file: [],
      steps: [
        {
          position: '',
          steps: ''
        }
      ],
      isEdit: false,
      themeList: [],
      themeWiseSkills: [],
      // deleteSkill: [],
      title: 'Week at a glance',
      allowedFiles: ['pdf', 'jpg', 'png', 'jpeg']
    }
  },
  created: async function () {
    this.title = this.dayId ? 'Edit Day at a glance' : 'Add Day at a glance'
    if (this.dayId) {
      this.isEdit = true
      await this.getIndividualDayDetails()
    }
    await this.getThemeList()
  },
  watch: {},
  methods: {
    save: async function () {
      try {
        for (let item of this.procedure) {
          if (item.stepTitle === '' || item.stepTime === '') {
            return this.errMsg('This field is required!')
          }
        }
        const procedures = []

        for (let i = 0; i < this.procedure.length; i++) {
          const procedure = {
            step: this.procedure[i].stepTitle,
            time: this.procedure[i].stepTime,
            steps: []
          }

          for (let j = 0; j < this.steps.length; j++) {
            const step = {
              steps: this.steps[j].steps,
              position: this.steps[j].position
            }

            procedure.steps.push(step)
          }

          procedures.push(procedure)
        }

        this.skills = this.skills.map((skill) => {
          return {
            skills: skill,
            isHighlighted: false
          }
        })

        let formData = {
          dayAtGlanceID: this.dayId,
          goal: this.goal,
          developmentArea: this.developmentArea,
          outcome: this.outcome,
          resourcesFromWowKit: this.resourceFromWowKit,
          others: this.others,
          preparation: this.preparation,
          skills: this.skills,
          procedure: procedures
        }
        // if (this.isEdit) {
        // delete this.dayAtGlanceID
        // add skill id in skills object
        // add procedures id and steps id in procedure
        // }

        if (this.isEdit) {
          let res = await http.put(
            `${CONSTANTS.API_URL}/api/curriculum_cms/update-dayatglance/2cebd6c7-339d-4d99-a199-b1c145211272`,
            formData
          )
          this.okMsg(res.data)
        } else {
          let res = await http.post(
            `${CONSTANTS.API_URL}/api/curriculum_cms/create-dayschedule`,
            formData
          )
          this.okMsg(res.data)
        }

        this.$router.push({ name: 'weekScheduleList' })
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    getIndividualDayDetails: async function () {
      try {
        let res = await http.get(
          `${CONSTANTS.API_URL}/api/curriculum_cms/get-dayatglance/${this.dayId}`
        )
        this.dayList = res.data.dayDetailsByID || null
        this.day = res.data.day || null
        this.week = res.data.week || null
        console.log('this.dayDetails L', this.dayList)
        res = res.data
        console.log('res : ', res)
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    uploadFile: async function () {
      try {
        let formData = {
          // procedureStepID: ,
          isDownloadable: this.isDownloadableValue,
          files: this.file
        }
        console.log('formData : ', formData)
        let res = await http.get(
          `${CONSTANTS.API_URL}/api/curriculum_cms/add-document`,
          formData
        )
        res = res.data
        console.log('res : ', res)
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    getThemeList: async function () {
      try {
        this.isLoading = true
        let res = await http.get(
          `${CONSTANTS.API_URL}/api/curriculum_cms/getall-themes`,
          {
            params: {
              page: 0,
              size: this.pageSize,
              search: this.search
            }
          }
        )
        this.themeList = res.data.rows
        this.totalPages = res.data.totalPages
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    fetchSkills: async function () {
      let skillArray = this.themeList.find((obj) => obj.id === this.themeName)
      if (skillArray) {
        this.themeWiseSkills = skillArray.Skills
      } else {
        this.themeWiseSkills = []
      }
    },

    deleteProcedureRow (e, item) {
      // if (item.id) {
      //   this.deleteSkill.push(item.id)
      // }
      if (this.procedure.length > 1) {
        this.procedure = _.filter(this.procedure, (a, b) => b !== e)
      } else {
        this.errMsg('Cannot delete! Atleast one procedure is required!')
      }
    },
    deleteStepsRow (e, item) {
      // if (item.id) {
      //   this.deleteSkill.push(item.id)
      // }
      console.log('this.steps : ', this.steps)

      if (this.steps.length > 1) {
        this.steps = _.filter(this.steps, (a, b) => b !== e)
      } else {
        this.errMsg('Cannot delete! Atleast one steps is required!')
      }
    },
    onFilechange (files) {
      // console.log(files, 'file new list')
      let r = files.filter((a, i) => {
        console.log('a : ', a)
        if (this.allowedFiles.includes(a.name.split('.').pop())) {
        }
        return this.allowedFiles.includes(a.name.split('.').pop())
      })
      this.files = r
    },
    deleteDropFile (files, i) {
      files.splice(i, 1)
    },
    okMsg (msg) {
      return this.$dialog.info({
        text: msg,
        title: 'Success'
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    }
  }
}
</script>
